import { useTable } from './table-state-provider';
import { TablePagination } from '../table-pagination/table-pagination';

const Pagination = () => {
  const { table, totalRowCount, isLoading } = useTable();
  const { pagination = { pageIndex: 0, pageSize: 100 }, grouping = [] } = table?.getState() ?? {};
  return (
    <TablePagination
      isLoading={isLoading}
      page={pagination.pageIndex + 1}
      pageSize={pagination.pageSize}
      onPageChange={(page, size) => {
        table?.setPagination({ pageIndex: page - 1, pageSize: size });
      }}
      count={totalRowCount ?? (table?.getPageCount() ?? 1) * pagination.pageSize}
      itemText={grouping.length > 0 ? 'groups' : 'items'}
    />
  );
};

export default Pagination;
